import InventoryProductsList from './InventoryProductsList';

export default InventoryProductsList;
